import { PaymentMedium, StripePaymentError } from 'shared/types/graphql';

export const maxInputAmount = 999999.99;
// Credit card fields for digital invoice form
export enum CreditCardFields {
  CardNumber = 'cardNumber',
  ExpirationMonth = 'expirationMonth',
  ExpirationYear = 'expirationYear',
  Cvc = 'cardCvc',
  Card = 'card', // If we decide to just go with the single input field (preferred)
}

// Our set of fields for credit card input
export const defaultCardValidationState = {
  cardNumber: false,
  cardExpiry: false,
  cardCvc: false,
  card: false, // If we decide to just go with the single input field (preferred)
};

export const STRIPE_ERROR_READABLE: Record<StripePaymentError, string> = {
  [StripePaymentError.Blocked]: 'The payment method cannot be used for payment',
  [StripePaymentError.CardNotSupported]: 'This card is not supported',
  [StripePaymentError.CurrencyNotSupported]: 'This card does not support the payment currency',
  [StripePaymentError.DuplicateTransaction]: 'The issuer identified this as a duplicate transaction',
  [StripePaymentError.ExpiredCard]: 'The card is expired',
  [StripePaymentError.Fraudulent]: 'The payment method cannot be used for payment',
  [StripePaymentError.GenericDecline]: 'The payment has failed. Please retry or have the cardholder contact the issuer',
  [StripePaymentError.IncorrectNumber]: 'The card number is incorrect',
  [StripePaymentError.IncorrectPin]: 'The PIN is incorrect',
  [StripePaymentError.IncorrectCvc]: 'The CVC is incorrect',
  [StripePaymentError.IncorrectPostalCode]: 'The postal code is incorrect',
  [StripePaymentError.InsufficientFunds]: 'The card has insufficient funds for this transaction',
  [StripePaymentError.InvalidAccount]: 'The card number is incorrect',
  [StripePaymentError.InvalidExpiry]: 'The provided expiration date is incorrect',
  [StripePaymentError.LostStolenCard]: 'The card has been reported as lost or stolen',
};

export interface PaymentMediumMap {
  [index: number]: PaymentMedium;
}

export const PAYMENT_MEDIUM_MAP: PaymentMediumMap = {
  0: PaymentMedium.StripeTerminal,
  1: PaymentMedium.StripeVirtualTerminal,
};

export const SEND_INVOICE_TO_TERMINAL = 'Send invoice to terminal';
export const ENTER_AMOUNT_AND_SELECT_TERMINAL =
  'Please enter an amount above $0.50 and select a terminal and client for this invoice.';
export const SEND_DIGITAL_INVOICE = 'Send credit/debit card invoice';
export const ENTER_AMOUNT_AND_SELECT_CLIENT =
  'Please enter an amount above $0.50, fill out the payment details, and select a client for this invoice.';
export const SELECT_PAYMENT_METHOD_TYPE = 'Please select a payment method type.';

export enum TriggerMessageEventPayloadDetailsStatus {
  Success = 'success',
  Errored = 'errored',
  Completed = 'completed',
  Pending = 'pending',
}

export enum TriggerMessageEventPayloadDetailsReason {
  NotFound = 'ClinicPetParent not found or not associated with a pims.',
  Integration = 'Clinic has no active Bitwerx integration.',
  FeatureFlag = 'Clinic missing required feature flag(s).',
  MissingAssociation = 'Clinic missing care discount pims payment type association.',
}

export interface CareAccountCreditIntent {
  id: string;
  paymentDue: number;
  writeback?: {
    triggered: boolean;
    reason?: TriggerMessageEventPayloadDetailsReason | null;
  };
}

export interface TriggerMessageEventInnerPayload {
  careAccountCreditIntent: CareAccountCreditIntent | null;
  followupId?: string;
  success?: boolean;
  usages?: {
    id: string;
  }[];
}

export interface TriggerMessageEventPayloadDetails {
  error: string | null;
  payload?: TriggerMessageEventInnerPayload[] | null;
  status?: TriggerMessageEventPayloadDetailsStatus | null;
}

export const MINIMUM_PAYMENT_AMOUNT = 0.5;
